export const authenticatorLinks = {
    'Play Market (Google Authenticator)':
        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
    'Play Market (Яндекс Ключ)': 'https://play.google.com/store/apps/details?id=ru.yandex.key&hl=ru&pli=1',
    'AppStore (Google Authenticator)': 'https://apps.apple.com/us/app/google-authenticator/id388497605',
    'AppStore (Яндекс Ключ)':
        'https://apps.apple.com/ru/app/%D1%8F%D0%BD%D0%B4%D0%B5%D0%BA%D1%81-%D0%BA%D0%BB%D1%8E%D1%87-%D0%B2%D0%B0%D1%88%D0%B8-%D0%BF%D0%B0%D1%80%D0%BE%D0%BB%D0%B8/id957324816',
};
